module.exports = __webpack_public_path__ + "email_38x38.4cab45ce4416b0e9b7320c0199cb87c6.png";